import axios from '@/axios';
import coreIAMUrl from '@/apis/coreIAM'

export default {
    fetchAll() {
        return axios.get(`${coreIAMUrl}/admin/fronts`)
    },
    fetchOne(uuid) {
        return axios.get(`${coreIAMUrl}/admin/fronts/${uuid}`);
    },
    createFront(id, name, description, url, redirectUris, webOrigins) {
        return axios.post(`${coreIAMUrl}/admin/fronts`, {
            application_id: id,
            application_name: name,
            application_description: description,
            root_url: url,
            redirect_uris: redirectUris,
            web_origins: webOrigins,
        });
    },
    updateFront(uuid, id, name, description, url, redirectUris, webOrigins) {
        return axios.patch(`${coreIAMUrl}/admin/fronts/${uuid}`, {
            application_id: id,
            application_name: name,
            application_description: description,
            root_url: url,
            redirect_uris: redirectUris,
            web_origins: webOrigins,
        });
    },
    deleteFront(uuid) {
        return axios.delete(`${coreIAMUrl}/admin/fronts/${uuid}`)
    },
    getDefaultScopes(uuid) {
        return axios.get(`${coreIAMUrl}/admin/fronts/${uuid}/default-scopes`)
    },
    addDefaultScope(uuid, scopeUuid) {
        return axios.post(`${coreIAMUrl}/admin/fronts/${uuid}/add-default-scopes`, {
            scope_uuid: scopeUuid
        })
    },
    removeDefaultScope(uuid, scopeUuid) {
        return axios.post(`${coreIAMUrl}/admin/fronts/${uuid}/remove-default-scopes`, {
            scope_uuid: scopeUuid
        })
    },
    getOptionalScopes(uuid) {
        return axios.get(`${coreIAMUrl}/admin/fronts/${uuid}/optional-scopes`)
    },
    addOptionalScope(uuid, scopeUuid) {
        return axios.post(`${coreIAMUrl}/admin/fronts/${uuid}/add-optional-scopes`, {
            scope_uuid: scopeUuid
        })
    },
    removeOptionalScope(uuid, scopeUuid) {
        return axios.post(`${coreIAMUrl}/admin/fronts/${uuid}/remove-optional-scopes`, {
            scope_uuid: scopeUuid
        })
    },
}